import { EMPTY_VALUE } from '../../constants';
import { isObject } from '../../field-viewer/type-guards';
import { getVatIDType } from './brazil-vat-id-validator';
export function normalizeVatIDValue({ fieldValue }) {
    const vatID = fieldValue;
    const isEmptyValue = fieldValue === EMPTY_VALUE;
    if (isEmptyValue) {
        return fieldValue;
    }
    if (fieldValue && isObject(fieldValue) && fieldValue.hasOwnProperty('id')) {
        if (fieldValue.hasOwnProperty('type')) {
            const type = getVatIDType(vatID.id);
            return {
                id: vatID.id,
                type
            };
        }
        return {
            id: vatID.id
        };
    }
    return EMPTY_VALUE;
}

//# sourceMappingURL=vat-id-normalize-value.js.map